export default __webpack_public_path__ + "static/media/Logo_brill_blauw_groot.5915be54.png";